/* Need to know drawer.
 *
 * Opens the right-hand panel behind the Delivery and returns trigger.
 *
 * The panel is moved to the end of <body> on init. position: fixed is measured
 * against the nearest transformed ancestor rather than the viewport, and the
 * product info column is sticky and sits inside sections Dawn animates with
 * transforms, so leaving the panel where it is authored would eventually pin it
 * to the wrong box. Moving it once removes the whole class of bug.
 *
 * The open sequence is deliberately two frames: unhide, force a reflow, then
 * add the class that drives the transform. Without the reflow the browser
 * collapses both style changes into one and the panel appears instead of
 * sliding.
 */
(function () {
  'use strict';

  var OPEN = 'is-open';
  var initialised = false;

  function init() {
    if (initialised) return;
    var drawer = document.getElementById('ResembleNeedToKnow');
    if (!drawer) return;
    initialised = true;

    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    var triggers = document.querySelectorAll('[aria-controls="ResembleNeedToKnow"]');
    var lastTrigger = null;

    function open(trigger) {
      lastTrigger = trigger || null;
      drawer.hidden = false;
      // Read a layout property so the unhide lands as its own style change.
      void drawer.offsetWidth;
      drawer.classList.add(OPEN);
      document.body.style.overflow = 'hidden';
      triggers.forEach(function (t) {
        t.setAttribute('aria-expanded', 'true');
      });
      var close = drawer.querySelector('.resemble-drawer__close');
      if (close) close.focus();
    }

    function close() {
      drawer.classList.remove(OPEN);
      document.body.style.overflow = '';
      triggers.forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
      if (lastTrigger) lastTrigger.focus();

      // Hide only once the slide-out has finished, so the panel does not
      // vanish mid-transition.
      var panel = drawer.querySelector('.resemble-drawer__panel');
      if (!panel) {
        drawer.hidden = true;
        return;
      }
      var done = function () {
        panel.removeEventListener('transitionend', done);
        if (!drawer.classList.contains(OPEN)) drawer.hidden = true;
      };
      panel.addEventListener('transitionend', done);
      // Fallback for the case where no transition runs at all.
      setTimeout(done, 700);
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        if (drawer.classList.contains(OPEN)) close();
        else open(trigger);
      });
    });

    drawer.querySelectorAll('[data-resemble-drawer-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains(OPEN)) close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Dawn re-renders sections in the theme editor without a page load.
  document.addEventListener('shopify:section:load', function () {
    initialised = false;
    init();
  });
})();
